const INTENTS = [
  { re: /\b(show|open|see|go to|take me to|where are|what are)\b.*\b(my )?(visits?|requests?|bookings?|dashboard|home)\b/i, to: "/dashboard", say: "Opening your visits." },
  { re: /\b(find|show|see|look for|search|browse|list)\b.*\b(helpers?|neighbours?|neighbors?|volunteers?)\b/i, to: "/helpers", say: "Here are the helpers near you." },
  { re: /\b(post|make|create|new|ask for)\b.*\b(request|help)\b|\bi need (a |some )?help with\b/i, to: "/post", say: "Let's ask for help." },
  { re: /\b(open|show|go to|check)\b.*\b(messages?|chat|inbox)\b/i, to: "/messages", say: "Opening your messages." },
  { re: /\b(open|show|go to|edit|change)\b.*\b(profile|settings|my details|pin)\b/i, to: "/profile", say: "Opening your profile." },
  { re: /\b(print|show)\b.*\b(my )?week\b|\bwhat('s| is) (on|happening) this week\b/i, to: "/dashboard?view=full", say: "Here is your week. Tap Print my week for a paper copy." },
  { re: /\b(emergency|sos|i need help now|help me now|call for help)\b/i, action: "sos", say: "Opening the emergency button. Press it if you need help right now." },
];

export function matchIntent(text) {
  const t = (text || "").trim();
  if (t.length > 120) return null;
  return INTENTS.find((i) => i.re.test(t)) || null;
}
